import React, {useEffect, useRef, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import * as yup from 'yup';
import {t} from 'react-switch-lang';
import {Toast} from '../../../../../utils/sweetAlert';
import {
  createExternalization,
  getCyclesByExternalizationId,
} from '../../../../../services/externalizations/externalizationService';
import {Col, Row} from 'react-bootstrap';
import Label from 'reactstrap/lib/Label';
import InputText from '../../../../../components/FormFields/InputText';
import SelectInfinite from '../../../../../components/FormFields/SelectInfinite';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import {
  externalizationStatuses,
  possessionOfLicencesOptions,
  yesNoOptions,
} from '../../../../../utils/externalizationFormOptions';
import SelectList from '../../../../../components/FormFields/select/SelectList';

const AddExternalization = (props) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const isSubmittingRef = useRef(false);
  const history = useHistory();
  const externalizationIdRef = useRef(null);
  const externalizationScheme = yup.object().shape({
    contractSubject: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .max(255, `${t('message.max', {max: 255})}`)
      .min(2, `${t('message.min', {min: 2})}`),
    serviceProvider: yup
      .object()
      .nullable()
      .required(t('message.fieldRequired')),
    externalizationForSubcontractor: yup
      .object()
      .nullable()
      .required(t('message.fieldRequired')),
  });
  const methods = useForm({
    resolver: yupResolver(externalizationScheme),
    mode: 'onSubmit',
  });
  const {handleSubmit, errors, register} = methods;

  const submitForm = async (data) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsButtonDisabled(true);
    const dataToSubmit = {
      contractSubject: data.contractSubject,
      serviceProvider: {id: data?.serviceProvider.value,
                        name: data?.serviceProvider?.label,
                        tin: data?.serviceProvider?.tin},
      status: 'ASSESSMENT_IN_PROGRESS',
      externalizationForSubcontractor: data?.externalizationForSubcontractor?.value
    };
    try {
   const res = await createExternalization(dataToSubmit)
      if (res?.status === 201) {
        Toast.fire({
          title: t('departments.message.addSuccess', {
            entity: t('externalization.riskProponentForm.addExternalization'),
          }),
          icon: 'success',
        });
        props.toggleModal();
        setIsButtonDisabled(false)
        const resultId = res?.data?.id
        const cycleResponse = await getCyclesByExternalizationId(resultId);
        const cycleData = cycleResponse?.data?.content;
        const cycleId = Array.isArray(cycleData) && cycleData.length > 0
          ? cycleData[0]?.id
          : null;
        if (cycleId) {
          setTimeout(() => {
            history.push(`/externalizations/${resultId}`, { dataToSubmit, resultId });
          }, 1000);
        }
      }
    } catch (err) {
      if (err?.response?.data?.code === 'externalization-already-exists') {
        Swal.fire({
          text: t('message.externalizationAlreadyExists'),
          icon: 'error',
        });
      } else {
        Toast.fire({
          title: t('message.errorApi'),
          icon: 'error',
        });
      }
    } finally {
      isSubmittingRef.current = false;
      setIsButtonDisabled(false);
    }};
  useEffect(() => {
    register({name: "serviceProvider", type: "custom"}, {required: true});
  }, []);
  useEffect(() => {
    if (errors.serviceProvider) {
      const select = externalizationIdRef.current.select;
      select.focus();
    }
  }, []);

  const handleCancel = (e) => {
    e.preventDefault();
    props.toggleModal();
  };
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitForm)}>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="contractSubject"> {t("externalization.riskProponentForm.contractSubject")}</Label>
            <InputText
              type="text"
              id="contractSubject"
              name="contractSubject"
              className={
                "form-control " +
                (errors.contractSubject !== undefined ? "error-field" : "")
              }
              placeholder={t("externalization.riskProponentForm.placeholder.contractSubject")}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="serviceProvider" className={"labelClass"}>
              {" "}
              {t("externalization.riskProponentForm.serviceProvider")}
            </Label>
            <SelectInfinite
              api={`/service-providers`}
              name="serviceProvider"
              className={errors.serviceProvider && "error-field"}
              placeholder={t("externalization.riskProponentForm.placeholder.serviceProvider")}
              queryKeys={"name.contains"}
              isExternalization={true}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="serviceProvider" className={"labelClass"}>
              {t("externalization.externalizationForSubcontractor")}
            </Label>
            <SelectList
              name="externalizationForSubcontractor"
              className="select"
              placeholder={t( 'externalization.placeholder.externalizationForSubcontractor')}
              options={yesNoOptions}
              isClearable
            />
          </Col>
        </Row>
        <Row className="submit-buttons-container mx-0">
          <Col sm={12} className="text-right px-0">
            <div className="submit">
              <button
                className="primary cancel"
                type="reset"
                onClick={(e) => handleCancel(e)}>
                {t("buttons.cancelBtn")}
              </button>
              <button type="submit" className="primary">
                {t("buttons.saveBtn")}
              </button>
            </div>
          </Col>
        </Row>
      </form>
    </FormProvider>
  );
};

export default AddExternalization;